import {useState} from 'react';
import {css} from '@emotion/css';
import Modal from 'patient-ping-remedy/packages/modal';
import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import DropdownList from 'patient-ping-remedy/packages/dropdown-list';
import {Value} from 'patient-ping-remedy/packages/dropdown-list/lib/DropdownList';
import {RejectionReason, REJECTION_REASONS, rejectionReasonDisplayValues} from '@/api/dto/care-journey';
import {sizes} from 'patient-ping-remedy/packages/theme';
import {StandardSmallTypography} from '@/components/pages/tasks/task_edit/progress/CareNoteSection.styles';
import {
  Textarea,
} from '@/components/pages/tasks/task_edit/progress/pre_review/CareJourneyPreReview.styles';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reasonCode: string, reasonText?: string) => void;
  isPending: boolean;
};

// Reject-with-reason modal for the pre-review screen (CARECO-5768).
export default function RejectReferralModal({isOpen, onClose, onConfirm, isPending}: Props) {
  const [reasonCode, setReasonCode] = useState<RejectionReason | null>(null);
  const [reasonText, setReasonText] = useState<string>('');

  const isOther = reasonCode === RejectionReason.OTHER;
  const canSubmit = Boolean(reasonCode) && (!isOther || reasonText.trim().length > 0);

  const reset = () => {
    setReasonCode(null);
    setReasonText('');
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleConfirm = () => {
    if (!reasonCode) return;
    onConfirm(reasonCode, isOther ? reasonText : undefined);
  };

  return (
    <Modal
      id="reject-referral-modal"
      headerText="Reject Referral"
      isOpen={isOpen}
      buttons={[
        <Button key="cancel" styleType={StyleType.TERTIARY} onClick={handleClose} disabled={isPending}>
          Cancel
        </Button>,
        <Button key="reject" onClick={handleConfirm} disabled={!canSubmit || isPending}>
          Reject Request
        </Button>,
      ]}
      className={css({width: '50rem'})}
    >
      <DropdownList
        id="reject-reason"
        label="Reason for rejection"
        aria-label="Reason for rejection"
        items={REJECTION_REASONS.map(reason => ({
          label: rejectionReasonDisplayValues[reason],
          value: reason,
        }))}
        value={reasonCode ? {
          label: rejectionReasonDisplayValues[reasonCode],
          value: reasonCode,
        } : null}
        handleChange={(val: Value | null) => setReasonCode((val?.value as RejectionReason) ?? null)}
        placeholder="Select a reason"
        required
        isWithinModal
      />
      {isOther && (
        <>
          <StandardSmallTypography className={css({display: 'block', marginTop: sizes.medium, marginBottom: sizes.xxSmall})}>
            Reason detail *
          </StandardSmallTypography>
          <Textarea
            aria-label="Reason detail"
            value={reasonText}
            onChange={event => setReasonText(event.target.value)}
          />
        </>
      )}
    </Modal>
  );
}
